import { useQuery } from "@tanstack/react-query";
import { getCategories } from "../../api/apiCategories";
import i18next from "i18next";

/**
 * Hook لجلب قائمة الفئات المفلترة
 * @param {Object} params - Query parameters (page, per_page, search, is_active, department_id, parent_id)
 */
export function useGetCategories(params = {}) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["categories", params, i18next.language],
        queryFn: () => getCategories(params),
        retry: false,
    });

    const categories = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params.per_page || 15, total: 0 };

    return { isLoading, error, categories, meta, refetch };
}
